

const NativePromptForm = ({
    addOverlay,
    setAddOverlay,
    overlayMessage,
    setOverlayMessage,
    overlayError,
}) => <>
    <div className="d-flex justify-content-between mb-2">
        <label>Add Overlay</label>
        <label className="toggle-control toggle-control-sm mb-2">
            <input type="checkbox" checked={addOverlay} onChange={() => setAddOverlay(!addOverlay)} />
            <span className="control"></span>
        </label>
    </div>
    {
        addOverlay && <div className="form-group">                   
            <label className="form-label text-dark regular full-width">Message on Overlay <span className="float-right">{overlayMessage?.length} / 200</span></label>
            <textarea 
                type="text" 
                rows="3"
                value={overlayMessage} 
                className="form-control" 
                onChange={({target}) => setOverlayMessage(target.value)}
                maxLength={200}
                ></textarea>
        </div>
    }
</>


export default NativePromptForm;